// @ts-nocheck

import json from './KL_collectibles.json';
import image from './KL_collectibles.png';

import atlas from '!!raw-loader!./KL_collectibles.atlas';

const skins = {
  BADGE_BAMBOOS: 'Badge_bambous',
  BADGE_DUO: 'Badge_binomes',
  BADGE_HUT: 'Badge_cabane',
  COMFORT_CHOCOLATE: 'Badge_confort_chocolat',
  COMFORT_HOTEL: 'Badge_confort_hotel',
  COMFORT_PIZZA: 'Badge_confort_pizza',
  BADGE_WATER: 'Badge_eau',
  BADGE_FIRECAMP: 'Badge_feu',
  BADGE_GRAND_BLUE: 'Badge_grand_bleu',
  BADGE_SLOTH: 'Badge_paresseux',
  BADGE_FISHING: 'Badge_peche',
  BADGE_BALANCE: 'Badge_equilibre',
  BADGE_RICE: 'Badge_riz',
};

const animations = {
  BADGE_WON: 'Badge',
  BADGE_FAIL: 'Badge_raté',
  BADGE_LOOP: 'Badge_loop',
  ORIENTATION_MARK_1_WON: 'Objets_carte_repère_1',
  ORIENTATION_MARK_1_FAIL: 'Objets_carte_repère_1_miss',
  ORIENTATION_MARK_2_WON: 'Objets_carte_repère_2',
  ORIENTATION_MARK_2_FAIL: 'Objets_carte_repère_2_miss',
  ORIENTATION_MARK_3_WON: 'Objets_carte_repère_3',
  ORIENTATION_MARK_3_FAIL: 'Objets_carte_repère_3_miss',
  ORIENTATION_TAG_1_WON: 'Objets_balise1',
  ORIENTATION_TAG_1_FAIL: 'Objets_balise1_miss',
  ORIENTATION_TAG_2_WON: 'Objets_balise2',
  ORIENTATION_TAG_2_FAIL: 'Objets_balise2_miss',
  ORIENTATION_TAG_3_WON: 'Objets_balise3',
  ORIENTATION_TAG_3_FAIL: 'Objets_balise3_miss',
  ORIENTATION_KNIFE_WON: 'Objets_couteau',
  ORIENTATION_KNIFE_FAIL: 'Objets_couteau_raté',
  ORIENTATION_KNIFE_MISS_1: 'Objets_couteau_miss_1',
  ORIENTATION_KNIFE_MISS_2: 'Objets_couteau_miss_2',
  ORIENTATION_KNIFE_MISS_3: 'Objets_couteau_miss_3',
  COLLAR_WON: 'Objets_collier',
  COLLAR_FAIL: 'Objets_collier_raté',
  COLLAR_USED: 'Objets_collier_utilisation',
  COLLAR_LOOP: 'Objets_collier_loop',
  ELIMINATION: 'Torche',
  VOTE: 'Vote',
};

export default {
  id: 'KL_collectibles',
  skins,
  animations,
  atlas,
  images: {
    'KL_collectibles.png': image,
  },
  json,
};
